'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('admin', {
    url: '/axby',
    template: require('./admin.html'),
    controller: 'AdminController',
    controllerAs: 'admin',
    authenticate: 'admin',
    redirectTo: 'admin.home',
    resolve: {
      stats: function stats(Applications) {
        return Applications.stats();
      }
    }
  }).state('admin.users', {
    url: '/users',
    template: require('./users.html'),
    controller: 'UsersController',
    controllerAs: '$userCtrl',
    authenticate: 'admin',
    resolve: {
      users: function users(Users) {
        console.log('USER FIND LIST');
        return Users.query();
      }
    }
  }).state('admin.apps', {
    url: '/apps',
    template: require('./apps.html'),
    controller: 'AppController',
    controllerAs: '$app',
    authenticate: 'admin',
    resolve: {
      apps: function apps(Applications, $localStorage) {
        $localStorage.type = $localStorage.type || 'MISC';
        $localStorage.year = $localStorage.year || '2018';
        return Applications.query({ type: $localStorage.type, year: $localStorage.year });
      },
      app: function app() {
        return {};
      },
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  }).state('admin.settings', {
    url: '/settings',
    template: require('./settings.html'),
    controller: 'AppSettingsController',
    controllerAs: '$setting',
    authenticate: 'admin',
    resolve: {
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  }).state('admin.home', {
    url: '/home',
    template: require('./home.html')
  }).state('admin.new', {
    url: '/new',
    template: require('./form.html'),
    controller: 'AppController',
    controllerAs: '$app',
    authenticate: 'admin',
    resolve: {
      apps: function apps() {
        return [];
      },
      app: function app() {
        return {};
      },
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  }).state('admin.form', {
    url: '/form/:id',
    template: require('./form.html'),
    controller: 'AppController',
    controllerAs: '$app',
    authenticate: 'admin',
    resolve: {
      apps: function apps() {
        return [];
      },
      app: function app(Applications, $stateParams) {
        return Applications.query({ id: $stateParams.id });
      },
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  }).state('admin.report', {
    url: '/report',
    template: require('./report.html'),
    controller: 'AppController',
    controllerAs: '$app',
    authenticate: 'admin',
    resolve: {
      apps: function apps(Applications, $localStorage) {
        $localStorage.type = $localStorage.type || 'MISC';
        $localStorage.year = $localStorage.year || '2018';
        return Applications.report({ type: $localStorage.type, year: $localStorage.year });
      },
      app: function app() {
        return {};
      },
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  }).state('admin.stickers', {
    url: '/stickers',
    template: require('./stickers.html'),
    controller: 'AppController',
    controllerAs: '$app',
    authenticate: 'admin',
    resolve: {
      apps: function apps() {
        return [];
      },
      app: function app() {
        return {};
      },
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  }).state('admin.app', {
    url: '/apps/:id',
    template: require('./app.html'),
    controller: 'AppController',
    controllerAs: '$app',
    authenticate: 'admin',
    resolve: {
      apps: function apps() {
        return [];
      },
      app: function app(Applications, $stateParams) {
        return Applications.query({ id: $stateParams.id });
      },
      settings: function settings(Settings) {
        return Settings.query();
      }
    }
  });
}


// WEBPACK FOOTER //
// ./client/app/admin/admin.routes.js